import { useEffect } from 'react'
import api from '../../services/api'
import { useEmotionRatingStore } from '../../stores/emotionRatingStore'

/** Fetch emotional ratings for the given participant refs (userIds / emails). */
export function useEmotionRatings(refs: string[]) {
  const setRatings = useEmotionRatingStore((s) => s.setRatings)
  const key = refs.slice().sort().join(',')
  useEffect(() => {
    if (!refs.length) { setRatings({}); return }
    let cancelled = false
    api.post('/workspace/service/person-index/batch', { refs })
      .then((r) => { if (!cancelled) setRatings(Object.fromEntries(Object.entries(r.data).map(([k, v]: [string, any]) => [k, v.index]))) })
      .catch(() => { if (!cancelled) setRatings({}) })
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])
}
